import { Component, Inject, Prop } from 'vue-property-decorator';
import { EstadoPrograma } from '@/shared/model/enumerations/estado-programa';
import { FiltroPrograma } from '@/shared/model/filtro-programa.model';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Area } from '@/shared/model/enumerations/area';
import ProgramaSelectComponent from '@/entities/snp/snippets/programa-select/programa-select.vue';
import ProgramaResumenComponent from '@/entities/snp/snippets/programa-resumen/programa-resumen.vue';
import { Programa } from '@/shared/model/programa.model';
import ProgramaService from '@/shared/programa/programa.service';
import isEqual from 'lodash.isequal';

@Component({
  components: {
    'programa-select': ProgramaSelectComponent,
    'programa-resumen': ProgramaResumenComponent,
  },
})
export default class ProgramaRegistroComponent extends ApeironComponent {
  @Inject('programaService') protected readonly programaService: () => ProgramaService;

  public filtro = new FiltroPrograma();

  @Prop({ required: false })
  public solucion: Solucion;

  public programaSeleccionado = false;

  /**
   * Bandera utilizada para validar si la información del programa asociado a la solicitud requiere actualización.
   */
  public actualizarPrograma = false;

  created() {
    this.filtro.coordinadorCvu = this.permisos.usuario.cvu;
    this.filtro.programaEstatus = EstadoPrograma.ELEGIBLE;
    this.filtro.area = this.solucion?.params?.area ?? Area.POSGRADOS;
    if (this.solucion) {
      this.filtro.tipoEspecial = this.solucion.params.tipoEspecial;
    }
    if (this.formModel?.programa) {
      this.form.programa = { ...this.form.programa, ...JSON.parse(JSON.stringify(this.formModel.programa)) };
      this.validaProgramaYActualiza('valida');
    }
    this.programaSeleccionado = this.formModel?.programa != undefined;
  }

  form: { programa?: Programa } = {};

  /**
   * Método que obtiene la información del programa para determinar si requiere actualización;
   * en caso de que se indique la acción de actualizar, se procederá a actualizar la información correspondiente de la solicitud.
   * @param accion Acción a realizar 'valida' o 'actualiza'
   */
  public validaProgramaYActualiza(accion: string) {
    this.programaService()
      .find(this.form.programa.id)
      .then(programa => {
        if ('valida' === accion) {
          this.actualizarPrograma = !this.validaPrograma(programa);
        } else if ('actualiza' === accion) {
          this.form.programa = programa;
          this.save(this.form);
          this.actualizarPrograma = false;
        }
      })
      .catch(() => {
        this.alertService().showError(this, this.$t('apeironGwApp.programa.actualizacioProgramaFalla').toString());
      })
      .finally(() => {});
  }

  /**
   * Valida que el programa registrado en la solicitud corresponda al mismo programa registrado en el SNP.
   * @param obj programa a validar
   * @returns true sino hay cambios, false si hay cambios
   */
  validaPrograma(obj: Programa) {
    return isEqual(obj, this.form.programa);
  }
}
